import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Swal from 'sweetalert2';
import './CustomModal.css';
import { actualizarSerie } from 'services/series';

// Un solo archivo y que sea Excel.
const EXTENSIONES_EXCEL = ['.xlsx', '.xls'];
const MAX_MB = 20;

export default function ModalActualizarSerie({ modal, toggle, token, IdUser, fetchData }) {
    const [archivo, setArchivo] = useState(null);
    const [error, setError] = useState('');
    const [subiendo, setSubiendo] = useState(false);

    const limpiar = () => {
        setArchivo(null);
        setError('');
        const input = document.getElementById('archivo-actualizar-serie');
        if (input) input.value = '';
    };

    const cerrar = () => {
        if (subiendo) return;
        limpiar();
        toggle();
    };

    const handleArchivoChange = (e) => {
        setError('');
        const seleccionado = e.target.files?.[0];
        if (!seleccionado) {
            setArchivo(null);
            return;
        }

        const nombre = seleccionado.name.toLowerCase();
        const esExcel = EXTENSIONES_EXCEL.some((ext) => nombre.endsWith(ext));
        if (!esExcel) {
            setArchivo(null);
            e.target.value = '';
            setError('El archivo debe ser un Excel (.xlsx o .xls).');
            return;
        }

        if (seleccionado.size > MAX_MB * 1024 * 1024) {
            setArchivo(null);
            e.target.value = '';
            setError(`El archivo no debe superar ${MAX_MB} MB.`);
            return;
        }

        setArchivo(seleccionado);
    };

    const handleSubir = async () => {
        if (!archivo) return;

        setSubiendo(true);
        setError('');
        try {
            const formData = new FormData();
            formData.append('archivo', archivo);
            formData.append('IdUser', IdUser);
            // La API es Laravel: enviamos POST + _method para que PHP llene $_FILES.
            // formData.append('_method', 'PATCH');

            const result = await actualizarSerie(token, formData);

            // Mismo formato de respuesta que usa ModalExceles: { response: { estado, mensaje, actualizados } }
            if (result?.response?.estado === 'Ok') {
                if (fetchData) await fetchData();
                limpiar();
                toggle();
                const actualizados = result.response.actualizados;
                const texto = actualizados !== undefined
                    ? `Se actualizaron ${actualizados} registro${actualizados === 1 ? '' : 's'}.`
                    : (result.response.mensaje || 'Series actualizadas correctamente.');
                Swal.fire({
                    icon: 'success',
                    text: texto,
                    confirmButtonColor: '#ed7100',
                });
            } else {
                setError(
                    result?.response?.mensaje ||
                    result?.message ||
                    'No se pudo actualizar. Revisa el archivo e inténtalo de nuevo.'
                );
            }
        } catch (err) {
            setError('Ocurrió un error al subir el archivo. Inténtalo de nuevo.');
        } finally {
            setSubiendo(false);
        }
    };

    return (
        <Modal
            isOpen={modal}
            toggle={cerrar}
            className="modal-actualizar"
            centered
            backdrop="static"
            keyboard={false}
        >
            <ModalHeader toggle={cerrar}>Actualizar series por archivo</ModalHeader>
            <ModalBody>
                {!archivo ? (
                    <label htmlFor="archivo-actualizar-serie" className="dropzone mb-1">
                        <span style={{ fontSize: 22 }}>📄</span>
                        <span>Haz clic para seleccionar un archivo</span>
                        <small>Formato Excel (.xlsx o .xls) · un solo archivo</small>
                    </label>
                ) : (
                    <div className="archivo-chip mb-1">
                        <span className="text-truncate">📄&nbsp;{archivo.name}</span>
                        <button
                            type="button"
                            title="Quitar archivo"
                            onClick={limpiar}
                            disabled={subiendo}
                        >
                            &times;
                        </button>
                    </div>
                )}

                <input
                    id="archivo-actualizar-serie"
                    type="file"
                    className="d-none"
                    accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    onChange={handleArchivoChange}
                    disabled={subiendo}
                />

                {error && <div className="text-danger mt-2 small">{error}</div>}
            </ModalBody>
            <ModalFooter>
                <button
                    className="btn btn-secondary btn-sm"
                    onClick={cerrar}
                    disabled={subiendo}
                >
                    Cancelar
                </button>
                <button
                    className="btn btn-info btn-sm"
                    onClick={handleSubir}
                    disabled={!archivo || subiendo}
                >
                    {subiendo ? 'Subiendo...' : 'Subir'}
                </button>
            </ModalFooter>
        </Modal>
    );
}
